// lib/msal.ts
import { PublicClientApplication } from "@azure/msal-browser";
import {
  REACT_PUBLIC_AZURE_CLIENT_ID,
  REACT_PUBLIC_AZURE_TENANT_ID,
  REACT_PUBLIC_REDIRECT_URI,
} from "src/URL";

export const msalConfig = {
  auth: {
    clientId: REACT_PUBLIC_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${REACT_PUBLIC_AZURE_TENANT_ID}`,
    redirectUri: `${REACT_PUBLIC_REDIRECT_URI}`,
    knownAuthorities: [
      `https://login.microsoftonline.com/${REACT_PUBLIC_AZURE_TENANT_ID}`,
    ],
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {},
};

// Validate configuration on startup
if (!msalConfig.auth.clientId) throw new Error("Azure Client ID is missing");
if (!msalConfig.auth.authority)
  throw new Error("Azure Authority URL is missing");

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance properly
msalInstance.initialize().catch((error) => {
  console.error("MSAL initialization failed:", error);
});
